function present(value) {
    return typeof value === 'string' && value.trim() !== '';
}

export const qrCodeContent = (env, mobileEnv, instanceEngineUri) => {
    const apiKey = mobileEnv?.apiKey;
    const engineUri = present(mobileEnv?.engineUri)
        ? mobileEnv.engineUri
        : instanceEngineUri;

    if (!present(apiKey) || !present(engineUri))
        return null;

    return `https://no2.tkt.lu/config?apiKey=${encodeURIComponent(apiKey)}&engineUri=${encodeURIComponent(engineUri)}&env=${encodeURIComponent(env)}`;
};
